import {configureStore} from '@reduxjs/toolkit';
import classesSlice from './classesSlice';


const store = configureStore({
    reducer:{
        classes: classesSlice.reducer
    }
});

export default store;